import { EditorAllProps } from './editor.js';
import { EventHandler } from './events.js';

export const isFunction = (x: unknown) => x && typeof x === 'function';

const isEventProp = (name: string) => {
  return name;
};

interface IEventHandlerSet {
  handler: EventHandler<any>;
  eventName: string;
}

const findEventHandlers = (
  props: Partial<EditorAllProps>
): IEventHandlerSet[] => {
  return Object.keys(props)
    .filter(isEventProp)
    .filter((name) => isFunction(props[name]))
    .map((name) => ({
      handler: props[name] as EventHandler<any>,
      eventName: name.substring(2),
    }));
};

export const bindHandlers = (
  editor: any,
  props: Partial<EditorAllProps>,
  boundHandlers: Record<string, (e: any) => void>
): void => {
  findEventHandlers(props).forEach((found) => {
    // Unbind old handler
    const oldHandler = boundHandlers[found.eventName];
    if (isFunction(oldHandler)) {
      editor.off(found.eventName, oldHandler);
    }

    // Bind new handler

    const newHandler = (e: any) => found.handler(e, editor);
    boundHandlers[found.eventName] = newHandler;
    editor.on(found.eventName, newHandler);
  });
};

let unique = 0;

export const uuid = (prefix: string): string => {
  const date = new Date();
  const time = date.getTime();
  const random = Math.floor(Math.random() * 1000000000);

  unique++;
  return `${prefix}_${random}_${unique}_${String(time)}`;
};

export const isTextarea = (
  element: Element | null
): element is HTMLTextAreaElement => {
  return element !== null && element.tagName.toLowerCase() === 'textarea';
};

const normalizePluginArray = (plugins?: string | string[]): string[] => {
  if (typeof plugins === 'undefined' || plugins === '') {
    return [];
  }

  return Array.isArray(plugins) ? plugins : plugins.split(' ');
};

export const mergePlugins = (
  initPlugins: string | string[],
  inputPlugins?: string | string[]
) => {
  return normalizePluginArray(initPlugins).concat(
    normalizePluginArray(inputPlugins)
  );
};
